import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import '@/elementui';
import { Message, Drawer } from "element-ui";
import fullscreen from 'vue-fullscreen'

Vue.use(fullscreen)
Vue.component(Message.name, Message)
Vue.use(Drawer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
